export type ToolProps = {
  id: string;
  value: string;
  isSelected: boolean;
  label: string;
  onChange: (e: any) => void;
};

export const Tool = ({ id, isSelected, label, value, onChange }: ToolProps) => {
  return (
    <div className={"atlas-py-3"} data-testid={"comparables-drawing-tool"}>
      <input id={id} onChange={onChange} value={value} type="radio" checked={isSelected} />
      <label className={"atlas-px-2"} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};
